var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VlButton',{attrs:{"mod-narrow":true,"title":"Genesys login"},on:{"click":_vm.openLoginUrl}},[_vm._v(" Login ")])}
var staticRenderFns = []

export { render, staticRenderFns }